// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2pXY5","title":"Info_title__1UeCr","links":"Info_links__3n6QM","link":"Info_link__1spyY","logo":"Info_logo__102_R"};